import { UserClient } from '@/../client-generator/generated-clients/user';
import axiosInstance from '../utilities/axios-instance';

const userClient = new UserClient('', axiosInstance as any);

export default userClient;
